import { useActivityPermissions } from "PFApp/activities/hooks";
import { Button } from "PFComponents/button";
import { Icon } from "PFComponents/icon";
import { useShortlistReset } from "PFCore/hooks/queries/shortlists/use_shortlist_actions";
import { Activity, Shortlist } from "PFTypes";
import { useTranslation } from "react-i18next";

import ButtonLabel from "../../../../activities/parts/button_label";

type DeclinedButtonsProps = {
  activity: Activity;
  item: Shortlist;
  qaPrefix: string;
};

const DeclinedButtons = ({ activity, item, qaPrefix }: DeclinedButtonsProps) => {
  const { t } = useTranslation("translation");
  const { mutate: resetShortlist } = useShortlistReset();
  const { canReviewShortlists: canUndo } = useActivityPermissions(activity);

  return (
    <>
      {canUndo && (
        <Button
          text={t("undo")}
          kind="blank"
          onClick={() => {
            resetShortlist(item.id);
          }}
          qaId={`${qaPrefix}-undo`}
        />
      )}
      <ButtonLabel>
        <Icon name="cross" size="sm" color="paletteRed0" />
        {t("declined")}
      </ButtonLabel>
    </>
  );
};

export default DeclinedButtons;
